import { join } from 'lodash';

export default class DashboardService {
    /* @ngInject */
    constructor($q, apiService) {
        this.$q = $q;
        this.apiService = apiService;
    }

    getCashFlowData(calendarIds, from, to) {
        return this.apiService.get(`/dashboard/cashflow`, {
            params: {
                from,
                to,
                calendars: join(calendarIds, ',')
            }
        }).then((result) => result.data || []);
    }
    
    getIncomeExpenseData(calendarIds, from, to) {
        return this.apiService.get(`/dashboard/income-expense`, {
            params: {
                from,
                to,
                calendars: join(calendarIds, ',')
            }
        }).then((result) => result.data || []);
    }
    
    getCategoryData(calendarIds, from, to, expense, confirmed) {
        let params = {
            from,
            to,
            calendars: join(calendarIds, ','),
            expense
        };

        if (typeof confirmed !== 'undefined') {
            params.confirmed = confirmed;
        }

        return this.apiService.get(`/dashboard/categories`, {
            params
        }).then((result) => result.data || []);
    }

    getExpenseCategoryData(calendarIds, from, to, confirmed) {
        return this.getCategoryData(calendarIds, from, to, true, confirmed);
    }
}



// WEBPACK FOOTER //
// ./src/application/service/dashboard/dashboard.service.js